import React, { FC, HTMLAttributes } from 'react';
import { merge } from '../../utils/utility';

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {}

export const Skeleton: FC<SkeletonProps> = ({ children, className, ...props }) => {
  return (
    <div {...props} className={merge('bg-gray-200 animate-pulse', className)}>
      {children}
    </div>
  );
};
